<script>
export default {
    name: "PrescriptionHistory",

    props: {

        prescriptionHistory: Array,
        showModal: Boolean,
        drug: Object,
    },

    methods: {

        printPrescriptionHistory() {
            let url = `/pharmacy/prescription-history`;
                url += `?patient=${this.drug.patientId}`;
                url += `&patientPrescriptionId=${this.drug.patientPrescriptionId}`;

            window.open(url, `_blank`, `PrescriptionHistory`);
        },
    },

}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-2/3 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Prescription History</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center">
            <div class="w-full overflow-auto">
                <table class="table table-hover">
                    <thead class="bg-blue-500 text-xs text-white">
                        <tr>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Prescription</th>
                            <th class="p-tiny">Ordered</th>
                            <th class="p-tiny">Issued</th>
                            <th class="p-tiny">Date</th>
                            <th class="p-tiny">Username</th>
                            <th class="p-tiny">Memo</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs">
                        <tr v-for="(prescription, idx) in prescriptionHistory" :key="idx">
                            <td class="p-tiny">{{ prescription.item }}</td>
                            <td class="p-tiny">{{ prescription.prescription || `-` }}</td>
                            <td class="p-tiny">{{ prescription.dosage || `-` }}</td>
                            <td class="p-tiny">{{ prescription.issued || `-` }}</td>
                            <td class="p-tiny">{{ prescription.date | dateFormat }}</td>
                            <td class="p-tiny">{{ prescription.user_Name }}</td>
                            <td class="p-tiny">{{ prescription.memo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button 
            class="btn-info btn-sm text-xs rounded" 
            @click.prevent="printPrescriptionHistory">
                <i class="fa fa-print"></i> Print</button>
      </template>
    </tail-modal>
</template>